import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slices/authSlice";
import contractorsReducer from "./Slices/contractorsSlice";
import accountingReportsReducer from "./Slices/AccountingReportsSlice";
import projectReportsReducer from "./Slices/ProjectReportsSlice";
import penaltyTypesReducer from "./Slices/PenaltyTypesSlice";
import employeePenaltiesReducer from "./Slices/EmployeePenaltiesSlice";
import employeeLoansReducer from "./Slices/EmployeeLoansSlice";
import boreholesReducer from "./Slices/boreholesSlice";
import {
  reduxPersistMiddleware,
  loadReduxState,
} from "./middleware/reduxPersistMiddleware";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    contractors: contractorsReducer,
    accountingReports: accountingReportsReducer,
    projectReports: projectReportsReducer,
    penaltyTypes: penaltyTypesReducer,
    employeePenalties: employeePenaltiesReducer,
    employeeLoans: employeeLoansReducer,
    boreholes: boreholesReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "REDUX_PERSIST_HYDRATE"],
      },
    }).concat(reduxPersistMiddleware),
});

// Load persisted state on app start
loadReduxState().then(persistedState => {
  if (persistedState) {
    // Dispatch hydrate action for each reducer
    if (persistedState.auth) {
      store.dispatch({ type: "auth/hydrate", payload: persistedState.auth });
    }
    if (persistedState.contractors) {
      store.dispatch({
        type: "contractors/hydrate",
        payload: persistedState.contractors,
      });
    }
    if (persistedState.accountingReports) {
      store.dispatch({
        type: "accountingReports/hydrate",
        payload: persistedState.accountingReports,
      });
    }
    if (persistedState.projectReports) {
      store.dispatch({
        type: "projectReports/hydrate",
        payload: persistedState.projectReports,
      });
    }
    if (persistedState.penaltyTypes) {
      store.dispatch({
        type: "penaltyTypes/hydrate",
        payload: persistedState.penaltyTypes,
      });
    }
    if (persistedState.employeePenalties) {
      store.dispatch({
        type: "employeePenalties/hydrate",
        payload: persistedState.employeePenalties,
      });
    }
    if (persistedState.employeeLoans) {
      store.dispatch({
        type: "employeeLoans/hydrate",
        payload: persistedState.employeeLoans,
      });
    }
    if (persistedState.boreholes) {
      store.dispatch({
        type: "boreholes/hydrate",
        payload: persistedState.boreholes,
      });
    }
  }
});

export default store;
